<template>
	<app-page>
		<app-heading :title="review.external_confirmation_id" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="review.history"
					:headers="headers"
					:sort-by="'processed'"
					:sort-desc="true"
					:dynamic="false"
				>
					<template v-slot:warning="{ item }">
						<span
							v-if="item.warning"
						>{{ item.warning }}</span>
						<span v-else>N/A</span>
					</template>
					<template v-slot:error="{ item }">
							<span
								v-if="item.error"
							>
								<app-tooltip :text="item.error">
									{{ item.error.substr(0, 50) }}
									<span v-if="item.error.length > 50">...</span>
								</app-tooltip>
							</span>
							<span v-else>N/A</span>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	async created() {
		try {
			this.review = await this.$ravello.request()
				.v(2)
				.to('reviews')
				.to(this.id)
				.get()
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
	data() {
		return {
			review: {
				history: [],
			},
			headers: [{
				text: 'Action',
				value: 'action',
				sortable: true,
			}, {
				text: 'Processed',
				value: 'processed',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'Warning',
				value: 'warning',
				sortable: false,
			}, {
				text: 'Error',
				value: 'error',
				sortable: false,
			}],
		}
	},
	computed: {
		id() {
			return this.$route.params.review
		},
	},
}
</script>
